import { ShipmentPermissions, UsersPermissions, LogisticsPermissions } from '../shared/dashboard/shipment.model';
import { ExtranetModule } from '../shared/modules-access/extranet-module.enum';
import { environment } from '../../environments/environment';

export async function disableByPermissions(navigation: Page[], permission: any) {
  const permissions = getPermissions<ShipmentPermissions>(permission);
  if (!permissions.includes(ShipmentPermissions.CanEdit)) {
    const editTranslates = ['addNew', 'edit', 'copy', 'addNew2'];
    navigation = disableByTranslates(navigation, editTranslates, ExtranetModule.Shipment);
  }
  if (!permissions.includes(ShipmentPermissions.CanRead)) {
    const readTranslates = ['all', 'tracking', 'all2'];
    navigation = disableByTranslates(navigation, readTranslates, ExtranetModule.Shipment);
  }
  return navigation;
}
export async function disableByLogisticsPermissions(navigation: Page[], permission: any) {
  const permissions = getPermissions<LogisticsPermissions>(permission);
  if (!permissions.includes(LogisticsPermissions.CanReadDocuments)) {
    const documentsTranslates = ['logisticsDocuments'];
    navigation = hideByTranslates(navigation, documentsTranslates);
  }
  if (!permissions.includes(LogisticsPermissions.WarehouseContent)) {
    const warehouseTranslates = ['warehouseContent'];
    navigation = hideByTranslates(navigation, warehouseTranslates);
  }
  if (!permissions.includes(LogisticsPermissions.CanReadIssueOrders)) {
    navigation = hideByTranslates(navigation, ['releaseOrders']);
  }
  if (!permissions.includes(LogisticsPermissions.CanReadReceiptOrders)) {
    navigation = hideByTranslates(navigation, ['deliveryOrders']);
  }
  return navigation;
}
function disableByTranslates(navigation: Page[], routes: string[], module: ExtranetModule) {
  return navigation.map((n) => {
    n.subNavigationItems = n.subNavigationItems.map(si => {
      if (routes.includes(si.translateName)) {
        si.disabled = true;
      }
      return si;
    })
    return n;
  });
}
function hideByTranslates(navigation: Page[], routes: string[]) {
  return navigation.map((n) => {
    n.subNavigationItems = n.subNavigationItems.map(si => {
      if (routes.includes(si.translateName)) {
        si.display = false;
      }
      return si;
    })
    return n;
  });
}


export function hasApiKeyPermission(permission: any) {
  const permissions = getPermissions<UsersPermissions>(permission)
  return permissions.includes(UsersPermissions.ApiKey);
}

function getPermissions<T>(permission: any): T[] {
  let permissions: T[];
  if (Array.isArray(permission)) {
    permissions = permission as T[]
  } else {
    permissions = [permission];
  }
  return permissions;
}


export const ROOT_NAVIGATION: Page[] = [
  {
    pathPatterns: [/^\/shipment$/, /^\/shipment\/new$/, /^\/shipment\/old$/, /^\/shipment\/tracking$/, /^\/shipment\/tracking\/\d*$/, /^\/shipment\/edit\/\d*$/, /^\/shipment\/copy\/\d*$/, /^\/shipment\/baselinker-token$/],
    translateName: 'shipments',
    path: 'shipment',
    module: ExtranetModule.Shipment,
    icon: 'assignment',
    subNavigationItems: [
      {
        translateName: 'all',
        path: 'shipment',
        module: ExtranetModule.Shipment
      },
      {
        translateName: 'addNew',
        path: 'shipment/new',
        module: ExtranetModule.Shipment,
      },

      // todo-mocked
      // {
      //   translateName: 'archive',
      //   path: 'shipment/old'
      // },
      {
        translateName: 'tracking',
        path: 'shipment/tracking',
        module: ExtranetModule.Shipment
      },
      {
        translateName: 'edit',
        path: 'shipment/edit',
        module: ExtranetModule.Shipment,
        display: false
      },
      {
        translateName: 'copy',
        path: 'shipment/copy',
        module: ExtranetModule.Shipment,
        display: false
      },
      {
        translateName: 'baselinker',
        path: 'shipment/baselinker-token',
        module: ExtranetModule.Shipment
      },
    ]
  },
  {
    pathPatterns: [/^\/agencies$/],
    translateName: 'agencies',
    path: 'agencies',
    module: ExtranetModule.Agencies,
    icon: 'library_books  ',
    subNavigationItems: [
      {
        translateName: 'requestsList',
        path: 'agencies',
        module: ExtranetModule.Agencies
      },
    ],
  },
  {
    pathPatterns: [/^\/settlements$/],
    translateName: 'settlements',
    path: 'settlements',
    module: ExtranetModule.Settlements,
    icon: 'attach_money  ',
    subNavigationItems: [
      {
        translateName: 'settlementsList',
        path: 'settlements',
        module: ExtranetModule.Settlements
      },
    ],
  },
  {
    pathPatterns: [/^\/logistics$/, /^\/logistics\/warehouse$/, /^\/logistics\/release-orders$/, /^\/logistics\/release-orders\/new$/, /^\/logistics\/delivery-orders$/, /^\/logistics\/delivery-orders\/new$/],
    translateName: 'logistics',
    path: 'logistics',
    module: ExtranetModule.Logistics,
    icon: 'local_shipping',
    subNavigationItems: [
      {
        translateName: 'logisticsDocuments',
        path: 'logistics',
        module: ExtranetModule.Logistics
      },
      {
        translateName: 'warehouseContent',
        path: 'logistics/warehouse',
        module: ExtranetModule.Logistics
      },
      {
        translateName: 'releaseOrders',
        path: 'logistics/release-orders',
        module: ExtranetModule.Logistics
      },
      {
        translateName: 'deliveryOrders',
        path: 'logistics/delivery-orders',
        module: ExtranetModule.Logistics
      },
    ],
  },
  {
    pathPatterns: [/^\/shipment\/contractors$/, /^\/shipment\/contractors\/new$/, /^\/shipment\/contractors\/\d*$/],
    translateName: 'contractors',
    path: 'shipment/contracotrs',
    module: ExtranetModule.Shipment,
    icon: 'business',
    subNavigationItems: [
      {
        translateName: 'all2',
        path: 'shipment/contractors',
        module: ExtranetModule.Shipment
      },
      {
        translateName: 'addNew2',
        path: 'shipment/contractors/new',
        module: ExtranetModule.Shipment
      }
    ]
  },
  {
    pathPatterns: [/^\/shipment\/settings$/, /^\/shipment\/settings\/other-settings$/, /^\/password$/],
    translateName: 'settings',
    path: '',
    module: ExtranetModule.All,
    icon: 'settings',
    subNavigationItems: [
      {
        translateName: 'profile',
        path: 'shipment/settings',
        module: ExtranetModule.Shipment
      },
      {
        translateName: 'other-settings',
        path: 'shipment/settings/other-settings',
        module: ExtranetModule.Shipment
      },
      {
        translateName: 'password',
        path: 'password',
        module: ExtranetModule.All
      },
    ]
  },
  {
    pathPatterns: [/^\/admin-panel\/users$/, /^\/admin-panel\/users\/new-user$/, /^\/admin-panel\/users\/edit-user\/[\w-]+$/],
    translateName: 'users',
    path: 'admin-panel',
    module: ExtranetModule.Users,
    icon: 'group',
    subNavigationItems: [
      {
        translateName: 'usersList',
        path: 'admin-panel/users',
        module: ExtranetModule.Users
      }, 
      {
        translateName: 'addUser',
        path: 'admin-panel/users/new-user',
        module: ExtranetModule.Users
      },
      {
        translateName: 'edit',
        path: 'admin-panel/users/edit-user',
        module: ExtranetModule.Users,
        display: false
      },
    ],
  },
  {
    pathPatterns: [/^\/archive\/notifications$/, /^\/archive\/consents$/],
    translateName: 'archive',
    path: 'archive',
    module: ExtranetModule.All,
    icon: 'archive',
    subNavigationItems: [
      {
        translateName: 'listNotifications',
        path: 'archive/notifications',
        module: ExtranetModule.All
      }, 
      {
        translateName: 'listConsents',
        path: 'archive/consents',
        module: ExtranetModule.All
      }
    ],
  },
  ...(environment.enableFeatureHelp ? [{
    pathPatterns: [/^\/help\/faq$/, /^\/help\/manuals$/],
    translateName: 'help',
    path: 'help/faq',
    module: ExtranetModule.All,
    icon: 'help_center',
    subNavigationItems: [
      {
        translateName: 'faq',
        path: 'help/faq',
        module: ExtranetModule.All
      },
      {
        translateName: 'manuals',
        path: 'help/manuals',
        module: ExtranetModule.All
      }
    ],
  }] : []),
  ...(environment.enableFeatureComplaints ? [{
    pathPatterns: [/^\/complaints$/],
    translateName: 'complaints',
    path: 'complaints',
    module: ExtranetModule.All,
    icon: 'report_problem',
    subNavigationItems: [
      {
        translateName: 'complaintsList',
        path: 'complaints',
        module: ExtranetModule.All
      },
    ],
  }] : [])
];

export interface Page {
  pathPatterns: RegExp[];
  path: string;
  module: ExtranetModule;
  translateName: string;
  icon: string;
  subNavigationItems: { translateName: string, path: string, display?: boolean, module: ExtranetModule, disabled?: boolean }[];
}


